// extracted by mini-css-extract-plugin
module.exports = {"disc-icon":"PlusInDiscIcon-module__disc-icon___2omND","plus-icon":"PlusInDiscIcon-module__plus-icon___VsP1Y"};